import { axiosInstance } from "@/plugins/axios";
import { Api } from "@/common/api/Api";
import FacilityRouter from "@/context/facility/router/FacilityRouter";
import { LocationAutocompleteView } from "@/context/location/model/LocationAutocompleteView";
import { AxiosInstance, AxiosResponse } from "axios";
import AutocompleteApi from "@/common/api/AutocompleteApi";

export class FacilityApi extends Api {
  constructor(axios: AxiosInstance) {
    super(FacilityRouter.BASE_PATH, axios);
  }

  public static async findAutocomplete(
    search: string,
    query: string
  ): Promise<Array<LocationAutocompleteView>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete(
      FacilityRouter.BASE_PATH,
      search,
      query
    );
    return response.data;
  }

  public static async findPage(query: string): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.get(
      FacilityRouter.BASE_PATH + "/p?" + query
    );
    return response;
  }

  public async findDashboard(query: string): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.get(
      FacilityRouter.BASE_PATH + "/d?" + query
    );
    return response;
  }
}

export const facilityApi = new FacilityApi(axiosInstance);
